import { render, staticRenderFns } from "./CardContentDefaultPublicPP.vue?vue&type=template&id=13437583&scoped=true&"
import script from "./CardContentDefaultPublicPP.vue?vue&type=script&lang=js&"
export * from "./CardContentDefaultPublicPP.vue?vue&type=script&lang=js&"
import style0 from "./CardContentDefaultPublicPP.vue?vue&type=style&index=0&id=13437583&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13437583",
  null
  
)

export default component.exports